import { CROP_PRODUCT_TYPE, CROP_PRODUCT_TYPES, CROP_VIRTUAL_PRODUCT_TYPE } from 'appConstants';
import type { IOrderProduct } from 'contexts/CropOrders';
import type { IEnvCropsProduct } from 'contexts/EnvCropsProducts';
import type { ICropFormikProduct } from 'types/product';

export const getProductTitle = (product: ICropFormikProduct) => {
  return `${product?.productData?.packagedItemDescription || ''} ${
    product.productType === CROP_PRODUCT_TYPE ? `(${product.productData.packageDescription})` : ''
  }`;
};

export const getCropProductTypeLabel = (productType: string) => {
  return productType === CROP_VIRTUAL_PRODUCT_TYPE
    ? CROP_PRODUCT_TYPES.VIRTUAL_PACK.label
    : CROP_PRODUCT_TYPES.PRODUCT.label;
};

export const getCropProductDescription = (product: IOrderProduct) => {
  return product.productType === CROP_VIRTUAL_PRODUCT_TYPE
    ? product.packagedItemDescription
    : `${product.packagedItemDescription} (${product.packageDescription})`;
};

export const getEnvCropsProductLabel = ({ itemDescription }: IEnvCropsProduct) => {
  return `${itemDescription || ''}`;
};
